module.exports = __webpack_public_path__ + "static/media/tiguan-allspace.80b8bc4c.png";